import React, { useEffect, useState } from 'react';
import B2BService from '../../API/B2BService';
import { IconCheck, IconArrowRight } from '../../components/icons';
import cl from './Modal.module.css';

/**
 * Модалка «Заказать счёт». Показывает 3 тарифа (один годовой dim,
 * актуальный годовой выделен), плюс помесячный. После сабмита создаёт
 * B2BRequest kind=invoice. Заявка падает в админку Майнкрафтии, админ
 * вручную выставит счёт и пришлёт его на email.
 */
export default function InvoiceModal({ onClose, defaultEmail, defaultPhone }) {
    const [pricing, setPricing] = useState(null);
    const [selectedKey, setSelectedKey] = useState(null);
    const [email, setEmail] = useState(defaultEmail || '');
    const [phone, setPhone] = useState(defaultPhone || '');
    const [submitting, setSubmitting] = useState(false);
    const [err, setErr] = useState('');
    const [done, setDone] = useState(false);

    useEffect(() => {
        B2BService.getPricing().then(p => {
            setPricing(p);
            // По умолчанию выбираем активный годовой
            const activeYearly = p?.plans?.find(x => x.period === 'год' && x.is_active);
            if (activeYearly) setSelectedKey(activeYearly.key);
        });
    }, []);

    async function submit(e) {
        e.preventDefault();
        setErr('');
        if (!selectedKey) { setErr('Выберите тариф'); return; }
        if (!email.trim()) { setErr('Укажите e-mail'); return; }

        const plan = pricing.plans.find(p => p.key === selectedKey);
        setSubmitting(true);
        const res = await B2BService.createRequest({
            kind: 'invoice',
            payload: {
                plan: selectedKey,
                amount: plan?.price,
                plan_name: plan?.name,
                period: plan?.period,
            },
            contact: { email: email.trim(), phone: phone.trim() || undefined },
        });
        setSubmitting(false);
        if (res.ok) {
            setDone(true);
        } else {
            setErr(res.message);
        }
    }

    return (
        <div className={cl.backdrop} onClick={onClose}>
            <div className={cl.modal} onClick={e => e.stopPropagation()}>
                <button className={cl.close} onClick={onClose} aria-label="Закрыть">×</button>

                {done ? (
                    <div className={cl.done}>
                        <div className={cl.doneIcon}>
                            <IconCheck width={42} height={42} strokeWidth={3}/>
                        </div>
                        <h2 className={cl.title}>Заявка отправлена</h2>
                        <p className={cl.lead}>
                            Мы получили вашу заявку и в течение 1 рабочего дня
                            пришлём счёт на e-mail <b>{email}</b>.
                            После оплаты подписка активируется автоматически.
                        </p>
                        <button className={cl.btnPrimary} onClick={onClose}>Понятно</button>
                    </div>
                ) : (
                    <form onSubmit={submit}>
                        <h2 className={cl.title}>Заказать счёт</h2>
                        <p className={cl.lead}>
                            Выберите тариф — мы пришлём счёт на оплату от ИП Иванкова В. С.
                            на указанный e-mail. Оплата проходит через ваш банк-клиент.
                        </p>

                        {err && <div className={cl.err}>{err}</div>}

                        <div className={cl.plans}>
                            {(pricing?.plans || []).map(p => {
                                const dimmed = p.period === 'год' && !p.is_active;
                                const checked = selectedKey === p.key;
                                return (
                                    <label key={p.key}
                                        className={[
                                            cl.planRow,
                                            checked && cl.planChecked,
                                            dimmed && cl.planDimmed,
                                        ].filter(Boolean).join(' ')}>
                                        <input type="radio"
                                            name="plan"
                                            value={p.key}
                                            checked={checked}
                                            disabled={dimmed}
                                            onChange={() => setSelectedKey(p.key)}/>
                                        <div className={cl.planMain}>
                                            <div className={cl.planName}>{p.name}</div>
                                            <div className={cl.planSub}>
                                                {dimmed
                                                    ? `Доступно ${p.active_months}`
                                                    : p.description}
                                            </div>
                                        </div>
                                        <div className={cl.planPrice}>
                                            {formatPrice(p.price)} ₽ <span>/ {p.period}</span>
                                        </div>
                                    </label>
                                );
                            })}
                        </div>

                        <div className={cl.field}>
                            <label htmlFor="email">E-mail для счёта</label>
                            <input id="email" type="email" required value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="you@example.com"/>
                            <span className={cl.fieldHint}>
                                Можете изменить — счёт уйдёт на этот адрес.
                            </span>
                        </div>
                        <div className={cl.field}>
                            <label htmlFor="phone">Телефон (необязательно)</label>
                            <input id="phone" type="tel" value={phone}
                                onChange={e => setPhone(e.target.value)}
                                placeholder="+7 ___ ___-__-__"/>
                        </div>

                        <button type="submit" className={cl.btnPrimary} disabled={submitting}>
                            {submitting
                                ? 'Отправляем…'
                                : <>Отправить заявку <IconArrowRight width={16} height={16}/></>
                            }
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}


function formatPrice(n) {
    return new Intl.NumberFormat('ru-RU').format(n);
}
